import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from "@angular/router";

import jwt_decode from "jwt-decode";
import { NotificationReadService } from "../_services/notificacion-read.service";
import { TokenStorageService } from "../_services/token-storage.service";
import { NotificationI18nService } from "../core/util/notification-i18n.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenStorageService,
    private notificacionesService: NotificationReadService,
    private _notificationI18n: NotificationI18nService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let token = this.tokenService.getToken();

    if (token != null) {
      var decodedToken: any = jwt_decode(token);
      var expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;

      if (expired) {
        this.tokenService.signOutExpirationAndRedirectTo("login");
        window.location.reload();
        return false;
      } else {
        const user = this.tokenService.getUser();
        const action = route.queryParamMap.get('action');

        // Perfil incompleto: solo redirigir a action=20 si intentan otra action.
        if (action && action !== '20' && (user.email == null || user.telefono == null)) {
          this._notificationI18n.warning('COMMON.PROFILE_INCOMPLETE');
          this.router.navigate(['/perfil'], { queryParams: { action: 20 } });
          return false;
        }

        this.notificacionesService.updateAlertMap();
      }
    } else {
      let params = { route: this.getPreviousUrl(state) };
      this.router.navigate(["login"], { queryParams: params })
      return false;
    }
    return true;
  }

  private getPreviousUrl(routerState: RouterStateSnapshot): string {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    let url = route.url.toString();
    const queryParams = route.queryParams;
    if (Object.keys(queryParams).length > 0) {
      const queryString = Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");
      url += `?${queryString}`;
    }
    return url;
  }
}
